import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

const bootstrap = () => bootstrapApplication(AppComponent, appConfig);

if (typeof document !== 'undefined') {
  // Bootstrap failure leaves a blank page. Nothing is logged (the app ships without
  // console output), so the error is parked on window for post-mortem inspection
  // via `__guluBootstrapError` instead of vanishing entirely.
  bootstrap().catch((err: unknown) => {
    (window as unknown as { __guluBootstrapError?: unknown }).__guluBootstrapError = err;
  });
}

export { bootstrap };
